import axios from 'axios';

export const axiosApi = axios.create({
    withCredentials: true
});
//export const axiosApi = axios.create();

axiosApi.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

//リクエストURLにタイムスタンプを付加し、ブラウザキャッシュを無効にする
axiosApi.interceptors.request.use(function (config) {
    if (typeof config.params === 'undefined') {
      config.params = {};
    }
    if (typeof config.params === 'object') {
      if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams)
        config.params.append('_', Date.now().toString());
      else
        config.params._ = Date.now();
    }
    return config;
  });
  